import script from "./packageCard.vue?vue&type=script&setup=true&lang=js"
export * from "./packageCard.vue?vue&type=script&setup=true&lang=js"

import "./packageCard.vue?vue&type=style&index=0&id=7caba4e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7caba4e4"]])

export default __exports__